var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.alumnoForm.participante?.cvu,
              expression: "!alumnoForm.participante?.cvu",
            },
          ],
        },
        [
          _c(
            "b-col",
            [
              _c("h5", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("apeironGwApp.alumnoSnp.form.buscarAlumno")
                  ),
                },
              }),
              _vm._v(" "),
              _vm.solicitud?.planDeEstudios?.duracionOficial &&
              _vm.solicitud?.programa?.clave &&
              (_vm.solicitud.generaciones?.length ?? 0) > 0
                ? _c("buscador-persona", {
                    on: { selected: _vm.seleccionarAlumno },
                  })
                : _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("apeironGwApp.alumnoSnp.mensajeSecciones"))
                    ),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alumnoForm.participante?.cvu,
              expression: "alumnoForm.participante?.cvu",
            },
          ],
        },
        [
          _c(
            "b-col",
            [
              _c(
                "b-tabs",
                { staticClass: "m-1" },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title:
                          _vm
                            .$t("apeironGwApp.alumnoSnp.form.tab1")
                            .toString() + " *",
                        active: "",
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "p-1" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.cvuAlumno"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-cvu",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-cvu",
                                          state:
                                            !_vm.$v.alumnoForm.participante.cvu
                                              .$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.cvuAlumno"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante.cvu,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "cvu",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.cvu",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.curp"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-curp",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-curp",
                                          state:
                                            !_vm.$v.alumnoForm.participante.curp
                                              .$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.curp"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante.curp,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "curp",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.curp",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.nombreAlumno"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-nombre-alumno",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-nombre-alumno",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .nombre.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.nombreAlumno"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante.nombre,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "nombre",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.nombre",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.apellidoPaterno"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-apellido-paterno",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-apellido-paterno",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .apellidoPaterno.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.apellidoPaterno"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .apellidoPaterno,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "apellidoPaterno",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.apellidoPaterno",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.apellidoMaterno"
                                        ),
                                        "label-for": "input-apellido-materno",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-apellido-materno",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .apellidoMaterno.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.apellidoMaterno"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .apellidoMaterno,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "apellidoMaterno",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.apellidoMaterno",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.tipoBeca"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-tipo-beca",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          disabled:
                                            !_vm.esEscritura ||
                                            !!_vm.alumnoForm.id,
                                          name: "input-tipo-beca",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .tipoBeca.$invalid,
                                          options: _vm.tiposBeca,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .tipoBeca,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "tipoBeca",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.tipoBeca",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .tipoBeca.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.inicioGeneracion"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-inicio-generacion",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-inicio-generacion",
                                          options: _vm.fechasGeneracion,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.inicioGeneracion"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .inicioGeneracion.$invalid,
                                          disabled:
                                            !_vm.esEscritura ||
                                            (!!_vm.alumnoForm.id &&
                                              (_vm.alumnoForm.participante
                                                ?.tipoBeca?.clave ?? "") !=
                                                "SIN_BECA"),
                                        },
                                        on: {
                                          change: _vm.onChangeInicioGeneracion,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .inicioGeneracion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "inicioGeneracion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.inicioGeneracion",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .inicioGeneracion.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.duracionMeses"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-duracion-meses",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-duracion-meses",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.duracionMeses"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .duracionMeses.$invalid,
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .duracionMeses,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "duracionMeses",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.duracionMeses",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.inicioEstudios"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-inicio-estudios",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-inicio-estudios",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .inicioEstudios.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.inicioEstudios"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .inicioEstudios,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "inicioEstudios",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.inicioEstudios",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .inicioEstudios.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.calculadoInicioGeneracion"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.finEstudios"
                                            )
                                            .toString() + " *",
                                        "label-for": "input-fin-estudios",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-fin-estudios",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .finEstudios.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.finEstudios"
                                          ),
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .finEstudios,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "finEstudios",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.finEstudios",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .finEstudios.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.calculadoDuracionMeses"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.alumnoForm.participante?.fechaBaja,
                                  expression:
                                    "!alumnoForm.participante?.fechaBaja",
                                },
                              ],
                              attrs: { "b-row": "" },
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-badge",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.alumnoForm.participante
                                              .obtencionGrado,
                                          expression:
                                            "alumnoForm.participante.obtencionGrado",
                                        },
                                      ],
                                      staticClass: "accion-label",
                                      attrs: { pill: "", variant: "light" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reiniciaCampoFechaObtencionGrado()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.alumnoSnp.acciones.resetField"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.obtencionGrado"
                                        ),
                                        "label-for": "input-obtencion-grado",
                                      },
                                    },
                                    [
                                      _c("b-form-datepicker", {
                                        attrs: {
                                          name: "input-obtencion-grado",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .obtencionGrado.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.obtencionGrado"
                                          ),
                                          disabled: !_vm.esEscritura,
                                          max: _vm.fechaHoy,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .obtencionGrado,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "obtencionGrado",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.obtencionGrado",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.alumnoForm.participante.obtencionGrado
                                      ?.length ?? 0) > 0,
                                  expression:
                                    "(alumnoForm.participante.obtencionGrado?.length ?? 0) > 0",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.acta"
                                          ) +
                                          ((_vm.alumnoForm.participante
                                            ?.obtencionGrado?.length ?? 0) > 0
                                            ? " *"
                                            : ""),
                                        "label-for": "input-acta",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-acta",
                                          options: _vm.opcionesActa,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.acta"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante.acta
                                              .$invalid,
                                          disabled:
                                            !_vm.esEscritura ||
                                            !(
                                              (_vm.alumnoForm.participante
                                                ?.obtencionGrado?.length ?? 0) >
                                              0
                                            ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.manejaCampoManejaActa()
                                          },
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante.acta,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "acta",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.acta",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .obtencionGrado.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.folioActa"
                                            )
                                            .toString() +
                                          ((_vm.alumnoForm.participante
                                            ?.obtencionGrado?.length ?? 0) >
                                            0 &&
                                          (_vm.alumnoForm.participante?.acta
                                            ?.clave ?? "") == "1"
                                            ? " *"
                                            : ""),
                                        "label-for": "input-folio-acta",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-folio-acta",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .folioActa.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.folioActa"
                                          ),
                                          disabled:
                                            !_vm.esEscritura ||
                                            !(
                                              (_vm.alumnoForm.participante
                                                ?.obtencionGrado?.length ?? 0) >
                                                0 &&
                                              (_vm.alumnoForm.participante?.acta
                                                ?.clave ?? "") == "1"
                                            ),
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .folioActa,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "folioActa",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.folioActa",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .folioActa.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.alumnoForm.participante.obtencionGrado
                                      ?.length ?? 0) > 0,
                                  expression:
                                    "(alumnoForm.participante.obtencionGrado?.length ?? 0) > 0",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.opcionGraduacion"
                                          ) +
                                          ((_vm.alumnoForm.participante
                                            ?.obtencionGrado?.length ?? 0) > 0
                                            ? " *"
                                            : ""),
                                        "label-for": "input-opcion-graduacion",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-opcion-graduacion",
                                          options: _vm.opcionesGraduacion,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.opcionGraduacion"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .opcionGraduacion.$invalid,
                                          disabled:
                                            !_vm.esEscritura ||
                                            !(
                                              (_vm.alumnoForm.participante
                                                ?.obtencionGrado?.length ?? 0) >
                                              0
                                            ),
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .opcionGraduacion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "opcionGraduacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.opcionGraduacion",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .opcionGraduacion.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.continuarAlGradoSuperior"
                                            )
                                            .toString() +
                                          ((_vm.alumnoForm.participante
                                            .obtencionGrado?.length ?? 0) > 0
                                            ? " *"
                                            : ""),
                                        "label-for":
                                          "input-continuar-al-grado-superior",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            name: "input-continuar-al-grado-superior",
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .continuarAlGradoSuperior
                                                .$invalid,
                                            disabled:
                                              !_vm.esEscritura ||
                                              !(
                                                (_vm.alumnoForm.participante
                                                  ?.obtencionGrado?.length ??
                                                  0) > 0
                                              ),
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .continuarAlGradoSuperior,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "continuarAlGradoSuperior",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.continuarAlGradoSuperior",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: true } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.si"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: false } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.no"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .continuarAlGradoSuperior
                                                .$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !(
                                    (_vm.alumnoForm.participante?.obtencionGrado
                                      ?.length ?? 0) > 0
                                  ),
                                  expression:
                                    "!((alumnoForm.participante?.obtencionGrado?.length ?? 0) > 0)",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-badge",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.alumnoForm.participante
                                              .fechaBaja,
                                          expression:
                                            "alumnoForm.participante.fechaBaja",
                                        },
                                      ],
                                      staticClass: "accion-label",
                                      attrs: { pill: "", variant: "light" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reiniciaCampoFechaBaja()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.alumnoSnp.acciones.resetField"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.fechaBaja"
                                        ),
                                        "label-for": "input-fechaBaja",
                                      },
                                    },
                                    [
                                      _c("b-form-datepicker", {
                                        attrs: {
                                          name: "input-fechaBaja",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.fechaBaja"
                                          ),
                                          disabled: !_vm.esEscritura,
                                          max: _vm.fechaHoy,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .fechaBaja,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "fechaBaja",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.fechaBaja",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.alumnoForm.participante.fechaBaja
                                      ?.length ?? 0) > 0,
                                  expression:
                                    "(alumnoForm.participante.fechaBaja?.length ?? 0) > 0",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-badge",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.alumnoForm.participante
                                              .reincorporacion,
                                          expression:
                                            "alumnoForm.participante.reincorporacion",
                                        },
                                      ],
                                      staticClass: "accion-label",
                                      attrs: { pill: "", variant: "light" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reiniciaCampoFechaReincorporacion()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.alumnoSnp.acciones.resetField"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.reincorporacion"
                                        ),
                                        "label-for":
                                          "input-fechaReincorporacion",
                                      },
                                    },
                                    [
                                      _c("b-form-datepicker", {
                                        attrs: {
                                          name: "input-fechaReincorporacion",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .reincorporacion.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.reincorporacion"
                                          ),
                                          disabled: !_vm.esEscritura,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .reincorporacion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "reincorporacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.reincorporacion",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !(
                                        (_vm.alumnoForm.participante
                                          ?.obtencionGrado?.length ?? 0) > 0
                                      ),
                                      expression:
                                        "!((alumnoForm.participante?.obtencionGrado?.length ?? 0) > 0)",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.motivoBaja"
                                        ),
                                        "label-for": "input-motivo-baja",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          name: "input-motivo-baja",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .motivoBaja.$invalid,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.motivoBaja"
                                          ),
                                          disabled:
                                            !_vm.esEscritura ||
                                            !(
                                              (_vm.alumnoForm.participante
                                                ?.fechaBaja?.length ?? 0) > 0
                                            ),
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .motivoBaja,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "motivoBaja",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.motivoBaja",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .motivoBaja.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.origenEstudiante"
                                          )
                                          .toString(),
                                        "label-for": "input-es-extranjero",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            id: "input-es-extranjero",
                                            name: "input-es-extranjero",
                                            value: true,
                                            "unchecked-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.manejadorCampoEsExtranjero()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .esExtranjero,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "esExtranjero",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.esExtranjero",
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm
                                                  .$t(
                                                    "apeironGwApp.alumnoSnp.form.esExtranjero"
                                                  )
                                                  .toString()
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    !_vm.alumnoForm.participante.esExtranjero,
                                  expression:
                                    "!alumnoForm.participante.esExtranjero",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.entidadFederativa"
                                            )
                                            .toString() +
                                          (_vm.alumnoForm.participante
                                            ?.esExtranjero ?? false
                                            ? ""
                                            : " *"),
                                        "label-for": "input-entidad-federativa",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          disabled: !_vm.esEscritura,
                                          name: "input-entidad-federativa",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .entidadFederativa.$invalid,
                                          options: _vm.entidadesFederativas,
                                        },
                                        on: { change: _vm.onChangeEntidad },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .entidadFederativa,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "entidadFederativa",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.entidadFederativa",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .entidadFederativa.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm
                                            .$t(
                                              "apeironGwApp.alumnoSnp.form.municipio"
                                            )
                                            .toString() +
                                          (_vm.alumnoForm.participante
                                            ?.esExtranjero ?? false
                                            ? ""
                                            : " *"),
                                        "label-for": "input-municipio",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          disabled: !_vm.esEscritura,
                                          name: "input-municipio",
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .municipio.$invalid,
                                          options: _vm.municipios,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .municipio,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "municipio",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.municipio",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .municipio.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.institucion"
                                          ) + " *",
                                        "label-for": "input-institucion",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-institucion",
                                          options: _vm.instituciones,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.institucion"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .institucion.$invalid,
                                          disabled: !_vm.esEscritura,
                                          title:
                                            _vm.alumnoForm.participante
                                              ?.institucion?.nombreInstitucion,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.seleccionarInstitucion()
                                          },
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .institucion,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "institucion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.institucion",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label:
                                          _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.sede"
                                          ) + " *",
                                        "label-for": "input-sede",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-sede",
                                          options: _vm.sedes,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.sede"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante.sede
                                              .$invalid,
                                          disabled: !_vm.esEscritura,
                                          title: `${_vm.alumnoForm.participante?.sede?.nombreDependencia} (${_vm.alumnoForm.participante?.sede?.sede})`,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante.sede,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "sede",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.sede",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.participacion.becario.comprobanteEstudios"
                                        ),
                                        "label-for":
                                          "input-comprobante-estudios",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .comprobanteEstudios.$invalid,
                                            size: "md",
                                            disabled: !_vm.esEscritura,
                                            name: "input-comprobante-estudios",
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .comprobanteEstudios,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "comprobanteEstudios",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.comprobanteEstudios",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.persona.participacion.becario.comprobanteEstudiosDescripcion"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.persona.participacion.becario.comprobanteNacionalidad"
                                        ),
                                        "label-for":
                                          "input-comprobante-nacionalidad",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .comprobanteNacionalidad
                                                .$invalid,
                                            size: "md",
                                            disabled: !_vm.esEscritura,
                                            name: "input-comprobante-nacionalidad",
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .comprobanteNacionalidad,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "comprobanteNacionalidad",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.comprobanteNacionalidad",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.persona.participacion.becario.comprobanteNacionalidadDescripcion"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm
                          .$t("apeironGwApp.alumnoSnp.form.tab2")
                          .toString(),
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "p-1" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tieneProtocolo"
                                          )
                                          .toString(),
                                        "label-for":
                                          "input-comprobante-nacionalidad",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            name: "tiene-protocolo",
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .tieneProtocolo.$invalid,
                                            disabled: !_vm.esEscritura,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.reiniciaCampoProtocolo()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .tieneProtocolo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "tieneProtocolo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.tieneProtocolo",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: true } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.si"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: false } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.no"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.protocolo"
                                        ),
                                        "label-for": "input-protocolo",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          name: "input-protocolo",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.protocolo"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .protocolo.$invalid,
                                          rows: "3",
                                          disabled:
                                            !_vm.esEscritura ||
                                            !_vm.alumnoForm.participante
                                              ?.tieneProtocolo,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .protocolo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "protocolo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.protocolo",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.$v.alumnoForm.participante.protocolo
                                        .$invalid
                                        ? _c("small", {
                                            staticClass: "text-danger",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.validacionCaracteresMinimos"
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "float-right" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.alumnoForm.participante
                                                  ?.protocolo?.length ?? 0
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tieneImpactoCientifico"
                                          )
                                          .toString(),
                                        "label-for":
                                          "input-tiene-impacto-cientifico",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            name: "input-tiene-impacto-cientifico",
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .tieneImpactoCientifico
                                                .$invalid,
                                            disabled: !_vm.esEscritura,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.reiniciaCampoImpactoCientifico()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .tieneImpactoCientifico,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "tieneImpactoCientifico",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.tieneImpactoCientifico",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: true } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.si"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: false } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.no"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.impactoCientifico"
                                        ),
                                        "label-for": "input-impacto-cientifico",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          name: "input-impacto-cientifico",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.impactoCientifico"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .impactoCientifico.$invalid,
                                          rows: "3",
                                          disabled:
                                            !_vm.esEscritura ||
                                            !_vm.alumnoForm.participante
                                              ?.tieneImpactoCientifico,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .impactoCientifico,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "impactoCientifico",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.impactoCientifico",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.$v.alumnoForm.participante
                                        .impactoCientifico.$invalid
                                        ? _c("small", {
                                            staticClass: "text-danger",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.validacionCaracteresMinimos"
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "float-right" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.alumnoForm.participante
                                                  ?.impactoCientifico?.length ??
                                                  0
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tieneImpactoSocial"
                                          )
                                          .toString(),
                                        "label-for":
                                          "input-tiene-impacto-social",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            name: "input-tiene-impacto-social",
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .tieneImpactoSocial.$invalid,
                                            disabled: !_vm.esEscritura,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.reiniciaCampoImpactoSocial()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .tieneImpactoSocial,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "tieneImpactoSocial",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.tieneImpactoSocial",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: true } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.si"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: false } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.no"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.impactoSocial"
                                        ),
                                        "label-for": "input-impacto-social",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          name: "input-impacto-social",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.impactoSocial"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .impactoSocial.$invalid,
                                          rows: "3",
                                          disabled:
                                            !_vm.esEscritura ||
                                            !_vm.alumnoForm.participante
                                              ?.tieneImpactoSocial,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .impactoSocial,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "impactoSocial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.impactoSocial",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.$v.alumnoForm.participante
                                        .impactoSocial.$invalid
                                        ? _c("small", {
                                            staticClass: "text-danger",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.validacionCaracteresMinimos"
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "float-right" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.alumnoForm.participante
                                                  ?.impactoSocial?.length ?? 0
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tieneAportacionesSolucionProblemasPrioritarios"
                                          )
                                          .toString(),
                                        "label-for":
                                          "input-tiene-aportaciones-solucion-problemas-prioritarios",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            name: "input-tiene-aportaciones-solucion-problemas-prioritarios",
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .tieneAportacionesSolucionProblemasPrioritarios
                                                .$invalid,
                                            disabled: !_vm.esEscritura,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.reiniciaCampoAportacionesSolucionProblemasPrioritarios()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .tieneAportacionesSolucionProblemasPrioritarios,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "tieneAportacionesSolucionProblemasPrioritarios",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.tieneAportacionesSolucionProblemasPrioritarios",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: true } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.si"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: false } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.no"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.aportacionesSolucionProblemasPrioritarios"
                                        ),
                                        "label-for":
                                          "input-aportaciones-solucion-problemas-prioritarios",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          name: "input-aportaciones-solucion-problemas-prioritarios",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.aportacionesSolucionProblemasPrioritarios"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .aportacionesSolucionProblemasPrioritarios
                                              .$invalid,
                                          rows: "3",
                                          disabled:
                                            !_vm.esEscritura ||
                                            !_vm.alumnoForm.participante
                                              ?.tieneAportacionesSolucionProblemasPrioritarios,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .aportacionesSolucionProblemasPrioritarios,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "aportacionesSolucionProblemasPrioritarios",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.aportacionesSolucionProblemasPrioritarios",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.$v.alumnoForm.participante
                                        .aportacionesSolucionProblemasPrioritarios
                                        .$invalid
                                        ? _c("small", {
                                            staticClass: "text-danger",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.validacionCaracteresMinimos"
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "float-right" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.alumnoForm.participante
                                                  ?.aportacionesSolucionProblemasPrioritarios
                                                  ?.length ?? 0
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tieneEstrategiaAccesoUniversalConocimiento"
                                          )
                                          .toString(),
                                        "label-for":
                                          "input-tiene-estrategia-acceso-universal-conocimiento",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            name: "input-tiene-estrategia-acceso-universal-conocimiento",
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .tieneEstrategiaAccesoUniversalConocimiento
                                                .$invalid,
                                            disabled: !_vm.esEscritura,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.reiniciaCampoEstrategiaAccesoUniversalConocimiento()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.alumnoForm.participante
                                                .tieneEstrategiaAccesoUniversalConocimiento,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.alumnoForm.participante,
                                                "tieneEstrategiaAccesoUniversalConocimiento",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "alumnoForm.participante.tieneEstrategiaAccesoUniversalConocimiento",
                                          },
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: true } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.si"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            { attrs: { value: false } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.alumnoSnp.form.no"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        "label-size": "md",
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.estrategiaAccesoUniversalConocimiento"
                                        ),
                                        "label-for":
                                          "input-estrategia-acceso-universal-conocimiento",
                                      },
                                    },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          name: "input-estrategia-acceso-universal-conocimiento",
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.estrategiaAccesoUniversalConocimiento"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .estrategiaAccesoUniversalConocimiento
                                              .$invalid,
                                          rows: "3",
                                          disabled:
                                            !_vm.esEscritura ||
                                            !_vm.alumnoForm.participante
                                              ?.tieneEstrategiaAccesoUniversalConocimiento,
                                        },
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .estrategiaAccesoUniversalConocimiento,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "estrategiaAccesoUniversalConocimiento",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.estrategiaAccesoUniversalConocimiento",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.$v.alumnoForm.participante
                                        .estrategiaAccesoUniversalConocimiento
                                        .$invalid
                                        ? _c("small", {
                                            staticClass: "text-danger",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "apeironGwApp.alumnoSnp.form.validacionCaracteresMinimos"
                                                )
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "float-right" },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.alumnoForm.participante
                                                  ?.estrategiaAccesoUniversalConocimiento
                                                  ?.length ?? 0
                                              ) +
                                              ")"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm
                          .$t("apeironGwApp.alumnoSnp.form.tab3")
                          .toString(),
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "p-1" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.trabaja"
                                        ),
                                        "label-for": "input-trabaja",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-trabaja",
                                          options: _vm.opcionesTrabaja,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.trabaja"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .trabaja.$invalid,
                                          disabled: !_vm.esEscritura,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.seleccionarTrabaja()
                                          },
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante.trabaja,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "trabaja",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.trabaja",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.alumnoSnp.form.empleadoEn"
                                        ),
                                        "label-for": "input-empleado-en",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        staticClass:
                                          "resaltar-opciones-disabled",
                                        attrs: {
                                          name: "input-empleado-en",
                                          options: _vm.opcionesEmpleadoEn,
                                          placeholder: _vm.$t(
                                            "apeironGwApp.alumnoSnp.form.empleadoEn"
                                          ),
                                          state:
                                            !_vm.$v.alumnoForm.participante
                                              .empleadoEn.$invalid,
                                          disabled:
                                            !_vm.esEscritura ||
                                            _vm.alumnoForm.participante?.trabaja
                                              ?.clave == "2",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "first",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-form-select-option",
                                                  {
                                                    attrs: {
                                                      value: undefined,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                          )
                                                          .toString()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.alumnoForm.participante
                                              .empleadoEn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.alumnoForm.participante,
                                              "empleadoEn",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "alumnoForm.participante.empleadoEn",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: {
                                            state:
                                              !_vm.$v.alumnoForm.participante
                                                .empleadoEn.$invalid,
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "entity.validation.required"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", [_c("b-col", [_c("hr")])], 1),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-right pb-2" },
            [
              _vm.esEscritura
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        type: "button",
                        variant: "primary",
                        disabled: _vm.formularioIsInvalid || _vm.guardando,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.guardarAlumno()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.alumnoSnp.acciones.guardar")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "save" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { type: "button", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.limpiarDatos()
                    },
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.alumnoSnp.acciones.reset")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "refresh" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }